import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaBigIntNode } from './TypedNode'
import { SchemaBigIntModel } from './ViewModel'

export const SchemaBigIntPlugin = createSchemaPlugin(
  'Schema.BigInt',
  SchemaBigIntModel,
  SchemaBigIntNode
)
